import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconKeyTakeawayAchievementGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M13.7377 16.1037L15.0177 10.673C15.0746 10.4334 15.0837 10.1849 15.0445 9.94176C15.0054 9.69861 14.9187 9.46556 14.7894 9.25592C14.6601 9.04629 14.4908 8.86419 14.2911 8.72002C14.0915 8.57584 13.8653 8.47243 13.6257 8.41568C13.3314 8.34589 13.0263 8.33474 12.7277 8.38287C12.4292 8.431 12.143 8.53747 11.8856 8.6962C11.6282 8.85493 11.4046 9.06281 11.2275 9.30796C11.0505 9.55312 10.9234 9.83076 10.8537 10.125L8.13367 21.6063L6.44434 23.141"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6653 20.296L12.432 17.0867C12.5089 16.7619 12.7117 16.481 12.9958 16.3057C13.2798 16.1304 13.6219 16.0751 13.9467 16.152C14.429 16.267 14.8461 16.5684 15.1067 16.9902C15.3674 17.412 15.4503 17.9199 15.3373 18.4027L14.192 23.2147C14.0089 23.9889 13.6432 24.708 13.1253 25.312L11.1533 27.848"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.24707 25.788L5.6644 22.3613L11.9417 28.6387L10.6724 29.912"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2907 16.1037L17.0107 10.673C16.9538 10.4334 16.9447 10.1849 16.9838 9.94173C17.023 9.69858 17.1097 9.46553 17.239 9.2559C17.3682 9.04627 17.5375 8.86416 17.7372 8.71999C17.9369 8.57581 18.163 8.4724 18.4027 8.41565C18.6968 8.34587 19.0019 8.33474 19.3003 8.38289C19.5988 8.43103 19.8849 8.53752 20.1422 8.69626C20.3995 8.855 20.623 9.06288 20.7999 9.30803C20.9768 9.55317 21.1037 9.83078 21.1733 10.125L23.8933 21.605L25.584 23.1397"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3642 20.296L19.5962 17.0866C19.5582 16.9259 19.489 16.7742 19.3924 16.6402C19.2958 16.5062 19.1737 16.3925 19.0332 16.3057C18.8926 16.2189 18.7364 16.1607 18.5733 16.1343C18.4102 16.1079 18.2436 16.1139 18.0828 16.152C17.6003 16.2667 17.1828 16.5679 16.9219 16.9898C16.661 17.4116 16.5779 17.9197 16.6908 18.4026L17.8362 23.2146C18.02 23.986 18.3847 24.7027 18.9002 25.3053L20.8762 27.848"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7536 25.7587L26.3642 22.3613L20.0869 28.6387L21.3149 29.8693"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0137 2.08789V4.58789"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9409 6.65625L25.1729 8.42425"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.05566 6.58398L6.82366 8.35198"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconKeyTakeawayAchievementSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <IconKeyTakeawayAchievementGroup {...props} />
    </svg>
  );
};
